module.exports = __webpack_public_path__ + "img/download-icon-new.bcf10b60.svg";